import { PlayFab, PlayFabClient, PlayFabAdmin, PlayFabServer } from "playfab-sdk";
import APIService from "../ApiService";
import {SetCollection} from "../App/index";
import firebase from "firebase";
import { databaseRef } from "../firebase";
import MainIndex from "../index";

//import { ChangeCompleteStatus, GetCompleteState, GetStartState } from "../BobbleContent/index";

let m_email = "";
let m_birth = "";
let m_zip = "";
let m_optIn = "false";
let playFabID = "";
let m_currentBobble: string = "";
//let m_OwnedPrizeID: string[] = ["",""];
let m_Scratched: Boolean = false;

export let prizeID: string = "";
/*function SetPrizeID(id: string) {
    prizeID = id;
}*/

let bobblesCollected: string[] = ["",""];
let prizesCollected: string[] = ["",""];

let bobbleIdToCheck: string = "";

function SetCurrentBobble(bobble:string) {
    m_currentBobble = bobble;
}

function GetBobbleID(): string[] {
    return bobblesCollected;
}

function GetCurrentBobble(): string {
    return m_currentBobble;
}

function GetPrizeString(index:string) {
    let indexNum: number = +index;
    //console.log("Set prize to: " + prizesCollected[indexNum]);
    return prizesCollected[indexNum];
}

/*function SetEmail(email:string) {
    m_email = email;
}*/

function SetBirth(birth:string) {
    m_birth = birth;
}

function SetOptIn(opt:string) {
    m_optIn = opt;
}

function SetZip(zip:string) {
    m_zip = zip;
}

function SetPlayFabId(id: string) {
    playFabID = id;
}

function getRandomPrizeValue(max:number) {
    let m_min: number = Math.ceil(1);
    let m_max: number = Math.floor(max);
    return Math.floor(Math.random() * (m_max - m_min + 1)) + m_min;
}

function GrantPrize() {
    /*if(GetCompleteState() && GetStartState()) {
        ChangeCompleteStatus(false);
    }*/
    let request: PlayFabClientModels.ExecuteCloudScriptRequest = {
        FunctionName: "getPrize" 
    };
    //console.log("calling cloud script");
    PlayFabClient.ExecuteCloudScript(request, ItemCallback);
}

function ItemCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabClientModels.ExecuteCloudScriptResult>) 
{
    if (result !== null) {
        //console.log(result.data.FunctionResult.EvaluateRandomResultTableResult.ResultItemId);
        prizeID = result.data.FunctionResult.EvaluateRandomResultTableResult.ResultItemId;
        let prizeNum: number = 0;
        if(prizeID === "TBR072001") {
            prizeID = "TBR072001_0001"
        } else if(prizeID === "TBR072002") {
            prizeNum = getRandomPrizeValue(500);
            if(prizeNum < 10) {
                prizeID = "TBR072002_000" + prizeNum.toString();
            } else if(prizeNum < 100) {
                prizeID = "TBR072002_00" + prizeNum.toString();
            } else {
                prizeID = "TBR072002_0" + prizeNum.toString();
            } 
        } else if(prizeID === "TBR072003") {
            prizeNum = getRandomPrizeValue(150);
            if(prizeNum < 10) {
                prizeID = "TBR072003_000" + prizeNum.toString();
            } else if(prizeNum < 100) {
                prizeID = "TBR072003_00" + prizeNum.toString();
            } else {
                prizeID = "TBR072003_0" + prizeNum.toString();
            } 
        } else if(prizeID === "TBR072004") {
            prizeNum = getRandomPrizeValue(20);
            if(prizeNum < 10) {
                prizeID = "TBR072004_000" + prizeNum.toString();
            }
        } else if(prizeID === "TBR072005") {
            prizeNum = getRandomPrizeValue(2);
            prizeID = "TBR072005_000" + prizeNum.toString();
        } else if(prizeID === "TBR072006") {
            prizeNum = getRandomPrizeValue(2);
            prizeID = "TBR072006_000" + prizeNum.toString(); 
        } else if(prizeID === "TBR072007") {
            prizeID = "TBR072007_0001";
        } else if(prizeID === "TBR072008") {
            prizeNum = getRandomPrizeValue(700);
            if(prizeNum < 10) {
                prizeID = "TBR072008_000" + prizeNum.toString();
            } else if(prizeNum < 100) {
                prizeID = "TBR072008_00" + prizeNum.toString();
            } else {
                prizeID = "TBR072008_0" + prizeNum.toString();
            } 
        } else if(prizeID === "TBR072010") {
            prizeNum = getRandomPrizeValue(200);
            if(prizeNum < 10) {
                prizeID = "TBR072010_000" + prizeNum.toString();
            } else if(prizeNum < 100) {
                prizeID = "TBR072010_00" + prizeNum.toString();
            } else {
                prizeID = "TBR072010_0" + prizeNum.toString();
            } 
        }

        if(MainIndex.GetBobbleID() === "M0") {
            prizeID = "NYM092001_0001";
        }

        //prizeID = "TBR072003_0062";
        //console.log(prizeID);
        CheckAvailable();
        //APIService.getCurrentPrizeImage(prizeID);
        //console.log(result.data.FunctionResult.EvaluateRandomResultTableResult.ResultItemId);
        //console.log("Congratulations, cloud success");
    } else if (error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function CheckAvailable() {
    if(prizeID === "TBR072001_0001" || prizeID === "NYM092001_0001") {
        APIService.setNewPrizeImage(prizeID);
        /*if(!GetCompleteState() && GetStartState()) {
            ChangeCompleteStatus(true);
        }*/
    } else {
        var request = {
            ItemId: prizeID
        };

        PlayFabAdmin.CheckLimitedEditionItemAvailability(request, AvailableCallback);
    }
}

function AvailableCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabAdminModels.CheckLimitedEditionItemAvailabilityResult>)
{
    if(result !== null) {
        //console.log(result.data.Amount);
        if(result.data.Amount > 0) {
            APIService.setNewPrizeImage(prizeID);
        }
        else {
            prizeID = "TBR072001_0001";
            APIService.setNewPrizeImage("TBR072001_0001");
        }
        /*if(!GetCompleteState() && GetStartState()) {
            ChangeCompleteStatus(true);
        }*/
        //SetAllUserData(m_zip, m_birth);
        //console.log(result);
        //GiveItem();
    } else if (error !== null) {
        //GrantPrize();
        prizeID = "TBR072001_0001";
        APIService.setNewPrizeImage(prizeID);
        console.log(CompileErrorReport(error));
    }
}

function GiveItem() {
    let request: PlayFabClientModels.ExecuteCloudScriptRequest = {
        FunctionName: "setPrize",
        FunctionParameter: {item: prizeID}
    };
    //console.log("calling cloud script");
    PlayFabClient.ExecuteCloudScript(request, PrizeCallback);
}

function PrizeCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabClientModels.ExecuteCloudScriptResult>) 
{
    if (result !== null) {
        firebase.analytics().logEvent('prize_granted', { prize: prizeID });
        //console.log(result.data.FunctionResult);
        //SetAllUserData(m_zip, m_birth);
        //console.log("Congratulations, item grant success");
    } else if (error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function DoExampleLoginWithCustomID(id:string) {
    PlayFab.settings.titleId = "A7CF5";
    //MASK THIS!!!!
    PlayFab.settings.developerSecretKey = "F4YTJOKPUMIKEH8MC7T669S44N46I11UX1FNSAZ1X8BPE4W34J";
    var loginRequest = {
        // Currently, you need to look up the correct format for this object in the API reference for LoginWithCustomID.
        TitleId: PlayFab.settings.titleId,
        CustomId: id,
        CreateAccount: true
    };

    PlayFabClient.LoginWithCustomID(loginRequest, LoginCallback);
}

function DoExampleLoginWithCustomIDReal(id:string) {
    if(MainIndex.GetBobbleID() === "M0") {
        PlayFab.settings.titleId = "97747";
        PlayFab.settings.developerSecretKey = "5Q7ZYPUMYPA4QEOEXMOBFB4XDFB5QEF1OMMJQZ1PBD7BJJOIGA";
    }

    var loginRequest = {
        TitleId: PlayFab.settings.titleId,
        CustomId: id,
        CreateAccount: true
    };
    m_email = id;
    PlayFabClient.LoginWithCustomID(loginRequest, LoginCallbackReal);
}

function ReturnUserLogin(email:string) {
    var request = {
        TitleId: PlayFab.settings.titleId,
        CustomId: email,
        CreateAccount: false
    };

    PlayFabClient.LoginWithCustomID(request, ReturnUserCallback);
}

function LoginCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabResultCommon) {
    if (result !== null) {
        //console.log("Congratulations, login success");
        GrantPrize();
    } else if (error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function LoginCallbackReal(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabClientModels.LoginResult>) {
    if (result !== null) {
        //console.log("Congratulations, login success");
        if(result.data.NewlyCreated === false) {
            //console.log("Not a new user");
            CheckUserDataForBobble(m_currentBobble);
            //SetBobbleData();
            //GetUserDataForBobble();
        }
        else {
            //console.log("Give new user bonus");
            //Enable this when ready
            if(MainIndex.GetBobbleID() !== "M0") {
                GiveItem();
            }
            //GrantPrize();
            if(result.data.PlayFabId) {
                SetPlayFabId(result.data.PlayFabId);
            }
            SetAllUserData(m_zip, m_birth);
        }
    } else if (error !== null) {
        console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function ReturnUserCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabClientModels.LoginResult>) {
    if(result !== null) {
        //console.log("Load returning users data");
        //GetUserDataForBobble();
        CheckUserDataForBobble(m_currentBobble);
        //SetBobbleData();
    } else if(error !== null) {
        console.log(CompileErrorReport(error));
    }
}

function SetAllUserData(zip:string, dob:string) {
    var currentBobble = m_currentBobble;
    //console.log("Current bobble ID is " + currentBobble);
    if(currentBobble === "0") {
        currentBobble = "AustinM";
    }else if(currentBobble === "1") {
        currentBobble = "SethR";
    }else if(currentBobble === "M0") {
        currentBobble = "MrMet";
    }
    
    var request = {
        Data: {Zipcode:zip, Birthdate:dob, OptIn:m_optIn, [currentBobble]: prizeID}
    };

    if(MainIndex.GetBobbleID() === "M0") {
        databaseRef.child("users/NYM/" + playFabID).set({
            email: m_email,
            birth: dob,
            zip: zip,
            opt: m_optIn,
            sku: prizeID
        });
    } else {
        databaseRef.child("users/TBR/" + playFabID).set({
            email: m_email,
            birth: dob,
            zip: zip,
            opt: m_optIn,
            sku: prizeID
        });
    }

    firebase.analytics().setUserProperties({email: m_email, zipcode: zip, birth: dob, opt: m_optIn})
    firebase.analytics().logEvent('registered_user', { email: m_email, zipcode: zip, birth: dob, opt: m_optIn});
    PlayFabClient.UpdateUserData(request, UserDataCallback);
}

function SetBobbleData() {
    var currentBobble = m_currentBobble;
    //console.log("playFab bobble: " + currentBobble);
    if(currentBobble === "0") {
        currentBobble = "AustinM";
    }else if(currentBobble === "1") {
        currentBobble = "SethR";
    }else if(currentBobble === "M0") {
        currentBobble = "MrMet"
    }
    //console.log("and after: " + currentBobble);
    var request = {
        Data: {[currentBobble]: prizeID}
    }

    PlayFabClient.UpdateUserData(request, BobbleDataCallback);
}

function GetUserDataForBobble() {
    let request: PlayFabClientModels.ExecuteCloudScriptRequest = {
        FunctionName: "getBobbleData",
    };

    PlayFabClient.ExecuteCloudScript(request, UserDataResponse);
}

function CheckUserDataForBobble(bobble:string) {
    bobbleIdToCheck = bobble;
    let request: PlayFabClientModels.ExecuteCloudScriptRequest = {
        FunctionName: "getBobbleData",
    };

    PlayFabClient.ExecuteCloudScript(request, CheckUserDataResponse);
}

function CheckUserDataResponse(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabClientModels.ExecuteCloudScriptResult>) {
    if(result !== null) {
        if(bobbleIdToCheck === "0" && result.data.FunctionResult.GetUserDataResult.Data.AustinM) {
            //console.log("Get bobble data");
            GetUserDataForBobble();
        } else if(bobbleIdToCheck === "1" && result.data.FunctionResult.GetUserDataResult.Data.SethR) {
            GetUserDataForBobble();
        } else {
            SetBobbleData();
        }
    } else if(error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function UserDataResponse(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabSuccessContainer<PlayFabClientModels.ExecuteCloudScriptResult>) {
    if (result !== null) {
        //console.log(result);
        m_Scratched = true;
        if(result.data.FunctionResult.GetUserDataResult.Data.AustinM) {
            //console.log("Found AustinM");
            bobblesCollected[0] = "0";
            prizesCollected[0] = result.data.FunctionResult.GetUserDataResult.Data.AustinM.Value;
        }
        if(result.data.FunctionResult.GetUserDataResult.Data.SethR) {
            //console.log("Found SethR");
            bobblesCollected[1] = "1";
            prizesCollected[1] = result.data.FunctionResult.GetUserDataResult.Data.SethR.Value;
        }
        if(result.data.FunctionResult.GetUserDataResult.Data.MrMet) {
            //console.log("Found SethR");
            bobblesCollected[2] = "M0";
            prizesCollected[2] = result.data.FunctionResult.GetUserDataResult.Data.MrMet.Value;
        }
        //prizeID = result.data.FunctionResult.GetUserDataResult.Data.AustinM.Value;
        //console.log(prizeID);
        //window.open("/?bid=0", "_self");
        SetCollection();
        //console.log("Congratulations, user data grab success");
    } else if (error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function UserDataCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabResultCommon) {
    if (result !== null) {
        //console.log("Congratulations, user data set");

        GetUserDataForBobble();
    } else if (error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

function BobbleDataCallback(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabResultCommon) {
    if (result !== null) {
        GetUserDataForBobble();
        //console.log("Congratulations, user data set");
    } else if (error !== null) {
        //console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}

/*function UserDataCallbackPrize(error: PlayFabModule.IPlayFabError, result: PlayFabModule.IPlayFabResultCommon) {
    if (result !== null) {
        console.log("Congratulations, user data prize set");
    } else if (error !== null) {
        console.log("Something went wrong with your first API call.");
        console.log("Here's some debug information:");
        console.log(CompileErrorReport(error));
    }
}*/

// This is a utility function we haven't put into the core SDK yet. Feel free to use it.
function CompileErrorReport(error:PlayFabModule.IPlayFabError) {
    if (error == null)
        return "";
    var fullErrors = error.errorMessage;
    for (var paramName in error.errorDetails)
        for (var msgIdx in error.errorDetails[paramName])
            fullErrors += "\n" + paramName + ": " + error.errorDetails[paramName][msgIdx];
    return fullErrors;
}

export default {
    SetBirth,
    SetZip,
    SetOptIn,
    SetCurrentBobble,
    GetCurrentBobble,
    SetBobbleData,
    GetBobbleID,
    DoExampleLoginWithCustomID,
    DoExampleLoginWithCustomIDReal,
    CheckUserDataForBobble,
    GetPrizeString,
    GrantPrize,
    GiveItem,
    ReturnUserLogin,
};